import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * This should only be able to be navigated to in 1.0 pi-spa. It is a legacy
 * component and 2.0 pi-platform uses `GlobalNavComponent`.
 */
@Component({
    selector: 'legacy-spa-pi-nav',
    template: `<nav class="piNav piNavSticky" #header>
        <div class="piNavPrimary">
            <div class="piNavPrimary--Main pageWidthLimiter">
                <div class="piNav--Logo">
                    <pi-nav-logo></pi-nav-logo>
                </div>
                <pi-header
                    class="piNavPrimary--Content"
                    [disableSearch]="disableSearch"
                ></pi-header>
            </div>
        </div>
        <div class="piNavSecondary">
            <div class="piNavPrimary--Main pageWidthLimiter">
                <pi-navigation-menu
                    class="piNav--Menu"
                    (onUpgradeAccountClick)="onUpgradeAccountClick.emit()"
                    [buttonTextKeyName]="buttonTextKeyName"
                    [showUpgradeButtonIcon]="true"
                ></pi-navigation-menu>
            </div>
        </div>
    </nav>`,
    standalone: false
})
export class LegacySpaNavComponent {
    @Input()
    disableSearch = false;

    @Output()
    onUpgradeAccountClick: EventEmitter<any> = new EventEmitter();
    @Input()
    buttonTextKeyName: string;
}
